import React from 'react';

function Foot(){
    return(
        <div>
<footer className="footer-wrapper">
            <div className="uper-text">
                    Responsive web app development has always been my passion ...and
                    if it's exactly your thing, I'm there to help! I guarantee you will be
                    satisfied with my work. I can develop your: #.Web site with react,
                    #.Web site with html, #.To deploy website

                Apple Vision Pro will be available early next year on <a href="#">apple.com</a> and at Apple retail
                stores in the U.S.
            </div>
            <div className="footer-link-wrapper">
                <div className="link-wrapper-1">
                    <h3>Standard</h3>
                    <ul>
                        <li><a href="#">Up to 10 pages</a></li>
                        <li><a href="#"> Responsive Web Pages</a></li>
                        <li><a href="#">Social media Integration</a></li>
                        <li><a href="#">responsive</a></li>
                        <li><a href="#">SEO Toolkit</a></li>
                        <li><a href="#">1 Year Revision</a></li>
                        <li><a href="#">Free Training</a></li>
                        <li><a href="#">Free 1 Year Domain and Hosting</a></li>
                        <li><a href="#">Content Management Dashboard</a></li>
                        <li><a href="#">Content Management system</a></li>
                        <li><a href="#">Free Training</a></li>
                            <div className="link-wrapper-2">
                                
                           









                            <h3>Apple Wallet</h3>
                            <li><a href="#">Wallet</a></li>
                            <li><a href="#">Apple card</a></li>
                            <li><a href="#">Apple pay</a></li>
                            <li><a href="#">Apple cash</a></li>
                        </div>
                    </ul>
                </div>
                <div className="link-wrapper-3">
                    <h3>Account</h3>
                    <ul>
                        <li><a href="#">Manage Your Apple ID</a></li>
                        <li><a href="#">Apple Store Account</a></li>
                        <li><a href="#">iCloud.com</a></li>
                        <div className="link-wrapper-4">
                            <h3>Entertainment</h3>
                            <li><a href="#">Apple One</a></li>
                            <li><a href="#">Apple TV+</a></li>
                            <li><a href="#">Apple Music</a></li>
                            <li><a href="#">Apple arcade</a></li>
                            <li><a href="#">Apple Fitness+</a></li>
                            <li><a href="#">Apple News+</a></li>
                            <li><a href="#">Apple Podcasts</a></li>
                            <li><a href="#">Apple Books</a></li>
                            <li><a href="#">App Store</a></li>
                        </div>
                    </ul>
                </div>
                <div className="link-wrapper-5">
                    <h3>Apple Store</h3>
                    <ul>
                        <li><a href="#">Find a Store</a></li>
                        <li><a href="#">Genius Bar</a></li>
                        <li><a href="#">Today at Apple</a></li>
                        <li><a href="#">Apple Camp</a></li>
                        <li><a href="#">Apple Store App</a></li>
                        <li><a href="#">Certified Refurbished</a></li>
                        <li><a href="#">Apple Trade In</a></li>
                        <li><a href="#">Financing</a></li>
                        <li><a href="#">Carrier Deals at Apple</a></li>
                        <li><a href="#">Order Status</a></li>
                        <li><a href="#">Shopping Help</a></li>
                    </ul>
                </div>
                <div className="link-wrapper-6">
                    <h3>For business</h3>
                    <ul>
                        <li><a href="#">Apple and Business</a></li>
                        <li><a href="#">Shop for Business</a></li>
                        <div className="link-wrapper-7">
                            <h3>For education</h3>
                            <li><a href="#">Apple and Education</a></li>
                            <li><a href="#">Shop for K-12</a></li>
                            <li><a href="#">Shop for College</a></li>
                        </div>
                        <div className="link-wrapper-8">
                            <h3>For Healthcare</h3>
                            <li><a href="#">Apple in Healthcare</a></li>
                            <li><a href="#">Health on Apple Watch</a></li>
                            <li><a href="#">Health Records on iPhone</a></li>
                        </div>
                        <div className="link-wrapper-9">
                            <h3>For Government</h3>
                            <li><a href="#">Shop for Government</a></li>
                            <li><a href="#">Shop for Veterans and Military</a></li>
                        </div>
                    </ul>
                </div>
                <div className="link-wrapper-10">
                    <h3>Apple Values</h3>
                    <ul>
                        <li><a href="#">Accessibility</a></li>
                        <li><a href="#">Education</a></li>
                        <li><a href="#">Environment</a></li>
                        <li><a href="#">Inclusion and Diversity</a></li>
                        <li><a href="#">Privacy</a></li>
                        <li><a href="#">Racial Equity and Justice</a></li>
                        <li><a href="#">Supplier Responsibility</a></li>
                        <div className="link-wrapper-11">
                            <h3>About Apple</h3>
                            <li><a href="#">Newsroom</a></li>
                            <li><a href="#">Apple Leadership</a></li>
                            <li><a href="#">Career Opportunities</a></li>
                            <li><a href="#">Investors</a></li>
                            <li><a href="#">Ethics & Compliance</a></li>
                            <li><a href="#">Events</a></li>
                            <li><a href="#">Contact Apple</a></li>
                        </div>
                    </ul>
                </div>
            </div>
        </footer>
        <section className="end">
            <div className="foot">
                <p>ways to shop: <a href="#">Find an Apple Store</a> or <a href="#">other retailer</a> near you. Or
                    call 1-800-MY-APPLE.</p>
            </div>
            <hr />
            <div className="last">
                <ul>
                    <li className="one">Copyright © 2023 Vision Inc. All rights reserved.</li>
                    <li className="two"><a href="#"> Privacy policy</a></li>
                    <li className="three"><a href="#"> Terms of use</a></li>
                    <li className="four"><a href="#"> Sells and refund</a></li>
                    <li className="five"><a href="#"> Legal</a></li>
                    <li className="six"><a href="#"> Site map</a></li>
                    <li className="seven"><a href="#">Ethiopia</a></li>
                </ul>
            </div>
        </section> 
        </div>
    )
}

export default Foot;
